import React from 'react';

import styles from './Reviews.m.sass';
import card from './Reviews.m.sass';

import TrustPilot from '../trustPilot/TrustPilot';
import StarRating from "../starRating/StarRating";

function Card({header, text, rating, author, date}) {
  return (
    <div className={card.card}>
      <div className={card.card_wrapper}>
        <div className={card.card_inner}>
          <blockquote className={card.card_quote}>
            <div className={card.card_quoteTop}>
              <header className={styles.card_quoteHeader}>{header}</header>
              <p className={card.card_quoteText}>{text}</p>
              <div className={card.card_rating}>
                <StarRating value={rating}/>
              </div>
            </div>
            <footer className={card.card_author}>
              <span className={styles.card_authorIcon}/>
              <span className={styles.card_authorName}>{author}</span>
              <span className={styles.card_authorDate}>{date}</span>
            </footer>
          </blockquote>
        </div>
      </div>
    </div>
  );
}


export default function Reviews({title}) {
  return (
    <section className={styles.reviews}>
      <div className="container">
        <h2 className={styles.reviews_header}>{title}</h2>

        <div className={styles.reviews_inner}>
          <div className={styles.reviews_trustpilot}>
            <TrustPilot solid/>
          </div>

          <div className={styles.reviews_cards}>
            <div className={styles.reviews_cardsWrapper}>
              <Card
                header="Really fun to play with"
                text="Really fun to play with, they have the best Monks i have every seen. I will use them again."
                rating={5}
                author="Leticia Mendez"
                date="5 hours ago"
              />

              <Card
                header="Awesome service"
                text="Awesome service. I got the run I was promised within about 10 minutes of paying."
                rating={4}
                author="Craig Renner"
                date="2 hours ago"
              />

              <Card
                header="Awesome experience guys are amazing"
                text="Awesome experience guys are amazing. Highly suggest using these guys. Way better then all the other websites I’ve tried."
                rating={5}
                author="Nenad Draca"
                date="40 min ago"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}



// WEBPACK FOOTER //
// ./components/reviews/Reviews.js